var map = {
	"./18.svg": 179,
	"./ShouldDelete.svg": 154,
	"./add_game.svg": 173,
	"./arrow-thin.svg": 81,
	"./arrowLeft.svg": 910,
	"./arrowRight.svg": 175,
	"./arrowRightThin.svg": 27,
	"./back.svg": 911,
	"./backspace.svg": 155,
	"./backward.svg": 912,
	"./betLogo.svg": 913,
	"./casinoRoulette.svg": 914,
	"./check.svg": 163,
	"./chevronDown.svg": 180,
	"./close-light.svg": 32,
	"./close.svg": 164,
	"./cross-eye.svg": 152,
	"./cross.svg": 31,
	"./delete.svg": 153,
	"./derbyLogo.svg": 915,
	"./edit.svg": 54,
	"./eye.svg": 151,
	"./filter.svg": 177,
	"./forward.svg": 111,
	"./four-dots.svg": 916,
	"./fullscreen-exit.svg": 172,
	"./fullscreen.svg": 171,
	"./ghost.svg": 150,
	"./heart.svg": 917,
	"./help.svg": 918,
	"./info-round.svg": 169,
	"./info.svg": 80,
	"./jackpot-diamond.svg": 166,
	"./jackpot-mobile.svg": 181,
	"./lightning-icon.svg": 77,
	"./like.svg": 919,
	"./minimize.svg": 174,
	"./nemId.svg": 920,
	"./nemkonto.svg": 165,
	"./newsletter.svg": 921,
	"./nyheder.svg": 922,
	"./offers.svg": 923,
	"./puzzle.svg": 102,
	"./ranking-bg.svg": 101,
	"./recommended.svg": 924,
	"./return.svg": 925,
	"./rodLogo.svg": 38,
	"./rodLogo_.svg": 926,
	"./rofus.svg": 39,
	"./search.svg": 79,
	"./sortArrows.svg": 178,
	"./star_wihout_bg.svg": 168,
	"./star_with_bg.svg": 167,
	"./succes.svg": 170,
	"./tableGames.svg": 927,
	"./trailing-arrow-transparent.svg": 176,
	"./trailing-arrow.svg": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 909;